import {useTranslation} from "react-i18next";
import React from "react";

const WhatYouGetBlock = ({ title, items }: { title?: string; items?: any[] }) => {
    const { t } = useTranslation();
    return (
        <div className="what-you-get-block">
            <div className="what-you-get-title">{title || t('subscription.whatYouGet')}</div>
            <ul className="what-you-get-list">
                {(items || [
                    t('subscription.aiToolGuides'),
                    t('subscription.beginnerLessons'),
                    t('subscription.skillBoosters'),
                    t('subscription.careerProjects'),
                    t('subscription.progressTracking'),
                    t('subscription.aiAssistant24'),
                ]).map((item, i) => {
                    let label = '';
                    let iconUrl = '';
                    let alt = '';
                    if (typeof item === 'string') label = item;
                    else if (typeof item === 'object' && item !== null) {
                        label = item.label || item.text || '';
                        alt = label || (item.icon && item.icon.name) || '';
                        if (item.icon) {
                            if (item.icon.formats && item.icon.formats.small && item.icon.formats.small.url) {
                                iconUrl = item.icon.formats.small.url;
                            } else if (item.icon.formats && item.icon.formats.thumbnail && item.icon.formats.thumbnail.url) {
                                iconUrl = item.icon.formats.thumbnail.url;
                            } else if (item.icon.url) {
                                iconUrl = item.icon.url;
                            }
                        }
                    }
                    return (
                        <li className="what-you-get-item" key={i}>
                            {iconUrl ? (
                                <img src={iconUrl} alt={alt} className="what-you-get-icon" />
                            ) : (
                                <span className="what-you-get-check">✅</span>
                            )}
                            <b>{label}</b>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default WhatYouGetBlock;
